export const sports_fitness = [
  { char: '💪', name: 'Bicep', nameZh: '力量/健身', keywords: ['gym', 'strong', 'muscle'], hot: true },
  { char: '🏋️', name: 'Weight Lifter', nameZh: '重訓', keywords: ['power', 'gym', 'workout'], hot: true },
  { char: '🏃', name: 'Runner', nameZh: '慢跑/前進', keywords: ['run', 'fast', 'cardio'] },
  { char: '🧘', name: 'Yoga', nameZh: '瑜珈/伸展', keywords: ['zen', 'stretch', 'health'], hot: true },
  { char: '🚴', name: 'Cyclist', nameZh: '騎行', keywords: ['bike', 'outdoor', 'sport'] },
  { char: '🏊', name: 'Swimmer', nameZh: '游泳', keywords: ['water', 'sea', 'pool'] },
  { char: '🎾', name: 'Tennis', nameZh: '網球', keywords: ['ball', 'sport'] },
  { char: '🏀', name: 'Basketball', nameZh: '籃球', keywords: ['ball', 'nba'] },
  { char: '⚽', name: 'Soccer', nameZh: '足球', keywords: ['ball', 'goal'] },
  { char: '🥊', name: 'Boxing', nameZh: '拳擊/挑戰', keywords: ['fight', 'power', 'knockout'], hot: true },
  { char: '🧗', name: 'Climbing', nameZh: '攀岩/攻頂', keywords: ['mountain', 'hike', 'top'] },
  { char: '🛹', name: 'Skateboard', nameZh: '極限運動', keywords: ['street', 'cool', 'skate'] },
];